import React, { useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import DriverStatus from "./Components/MasterSetup/DriverStatus";
import BusStatus from "./Components/MasterSetup/BusStatus";
import BookingStatus from "./Components/MasterSetup/BookingStatus";
import TripStatus from "./Components/MasterSetup/TripStatus";
import TripReason from "./Components/MasterSetup/TripReason";
import ModeofPayment from "./Components/MasterSetup/ModeofPayment";
import PaymentStatus from "./Components/MasterSetup/PaymentStatus";
import DriverDrinkingHabit from "./Components/MasterSetup/DriverDrinkingHabit";
import "../style/MasterSetup.css";
import ExpenseCategory from "./Components/MasterSetup/ExpenseCategory";
import { useLocation } from "react-router-dom";

export default function MasterSetup() {
  const location = useLocation();
  const passedState = location.state;

  const [currentForm, setCurrentForm] = useState("tripReason");
  const [isActive, setIsActive] = useState(7);

  const renderForm = () => {
    switch (currentForm) {
      case "driverStatus":
        return <DriverStatus />;
      case "busStatus":
        return <BusStatus />;
      case "bookingStatus":
        return <BookingStatus />;
      case "driverDrinkingHabits":
        return <DriverDrinkingHabit />;
      case "tripStatus":
        return <TripStatus />;
      case "paymentStatus":
        return <PaymentStatus />;
      case "modeofPayment":
        return <ModeofPayment />;
      case "tripReason":
        return <TripReason />;
      case "expenseCategory":
        return <ExpenseCategory />;
      default:
        return null;
    }
  };

  return (
    <>
      <Appbar
        username={passedState.username}
        rights={passedState.rights}
      ></Appbar>
      <div className="MasterSetup">
        <Menu
          username={passedState.username}
          rights={passedState.rights}
          i={"MasterSetup"}
        ></Menu>
        <div className="MasterSetupPage">
          <p className="MasterSetupPageHeadLabel">Master Setup</p>
          <div className="MasterSetupPageTabBox">
            <button
              title="Driver Status"
              className={
                isActive === 0
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(0);
                setCurrentForm("driverStatus");
              }}
            >
              {" "}
              Driver Status{" "}
            </button>
            <button
              title="bus Status"
              className={
                isActive === 1
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(1);
                setCurrentForm("busStatus");
              }}
            >
              Bus Status
            </button>
            <button
              title="Trip Status"
              className={
                isActive === 4
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(4);
                setCurrentForm("tripStatus");
              }}
            >
              Trip Status
            </button>
            <button
              title="Trip Reason"
              className={
                isActive === 7
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(7);
                setCurrentForm("tripReason");
              }}
            >
              Trip Reason
            </button>
            <button
              title="Booking Status"
              className={
                isActive === 2
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(2);
                setCurrentForm("bookingStatus");
              }}
            >
              Booking Status
            </button>
            <button
              title="Payment Status"
              className={
                isActive === 5
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(5);
                setCurrentForm("paymentStatus");
              }}
            >
              Payment Status
            </button>
            <button
              title="Driver Drinking Habits"
              className={
                isActive === 3
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(3);
                setCurrentForm("driverDrinkingHabits");
              }}
            >
              Driver Drinking Habit
            </button>
            <button
              title="Expense Category"
              className={
                isActive === 8
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(8);
                setCurrentForm("expenseCategory");
              }}
            >
              Expense Category
            </button>
            <button
              title="Mode of Payment"
              className={
                isActive === 6
                  ? "MasterSetupPageTabBtns Active"
                  : "MasterSetupPageTabBtns"
              }
              onClick={() => {
                setIsActive(6);
                setCurrentForm("modeofPayment");
              }}
            >
              Mode of Payment
            </button>
          </div>
          <div className="MasterSetupPageContent">{renderForm()}</div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
